import WYSIWYG from '@components/ui/WYSIWYG'
import config from '@config/seo_meta.json'
import cn from 'clsx'
import Image from "next/legacy/image"
interface Props {
  slice: any
}
const ArticleImageWithText = ({ slice }: Props) => {
  const { items } = slice
  return (
    <>
      <div className="wrapper bg-ui-light-grey pt-10 pb-16 lg:pt-20 lg:pb-[164px] ">
        {items && (
          <>
            <div className="flex flex-col gap-14 lg:gap-20">
              {items.map((item: any, index: number) => {
                const image = item?.image
                const imageCredit = item?.imageCredit
                const imageOnRight = item?.imagePosition
                const mainText = item?.mainText
                return (
                  <div key={index} className="relative lg:even:-mt-40">
                    <div className="flex flex-col gap-12 lg:flex-row lg:gap-36">
                      {mainText && (
                        <div
                          className={cn(
                            'mainText flex w-full text-brand-dark-grey lg:w-[640px]',
                            {
                              'order-1': !imageOnRight,
                              'items-end': !imageOnRight,
                            }
                          )}
                        >
                          <WYSIWYG content={mainText} />
                        </div>
                      )}
                      {image && image.url && (
                        <div className="relative flex h-[458px] w-full flex-col  lg:h-[705px] lg:w-[528px]">
                          <div className="relative h-full w-full lg:min-h-[705px]">
                            <Image
                              src={image?.url || '/product-img-placeholder.svg'}
                              alt={image?.alt || config.openGraph.images[0].alt}
                              layout="fill"
                              objectFit="cover"
                            />
                          </div>

                          {imageCredit && (
                            <div
                              className={cn(
                                'body-2 pt-3 text-brand-dark-grey',
                                {
                                  'lg:text-right': imageOnRight,
                                }
                              )}
                            >
                              {imageCredit}
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                )
              })}
            </div>
          </>
        )}
      </div>

      <style jsx global>
        {`
          .mainText .wysiwyg p {
            padding-bottom: 40px;
            font-family: Roboto, Arial, sans-serif;
            font-weight: 300;
            font-size: 16px;
            line-height: 24px;
          }
          .mainText .wysiwyg p:last-child {
            padding-bottom: 0px;
          }
        `}
      </style>
    </>
  )
}

export default ArticleImageWithText
